<template>
  <div class="registerfindPass w100 pr">
    <div class="registerfind_wrap">
      <div class="center mb35"><img src="@/assets/pass_logo.png"></div>
      <div class="registerfind_body white">
        <ul class="flex_middle register_table">
          <div>
            <li class="lh36 fs18 c3 bold">欢迎注册“微信运营”系统</li>
            <li class="c9 fs14">仅需简单5步，即可完成注册</li>
          </div>
        </ul>
        <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form" label-width="80px">
          <el-form-item prop="company_name" label="企业名称">
            <el-input v-model="registerForm.company_name" type="text" placeholder="请输入企业名称" clearable />
          </el-form-item>
          <el-form-item prop="duty" label="企业税号">
            <el-input v-model="registerForm.duty" type="text" placeholder="请输入企业税号" clearable />
          </el-form-item>
          <el-form-item prop="source" label="来源渠道">
            <el-select v-model="registerForm.source" class="w100" placeholder="请选择来源渠道">
              <el-option label="搜索引擎（百度、谷歌等）" value="search" />
              <el-option label="社交媒体（微信、微博、抖音等）" value="social" />
              <el-option label="推荐（朋友推荐、员工推荐）" value="recommend" />
              <el-option label="其他" value="other" />
            </el-select>
          </el-form-item>
          <el-form-item prop="account" label="登陆账号">
            <el-input v-model="registerForm.account" type="text" placeholder="请输入手机号" maxlength="11" clearable @input="inputAccount" />
          </el-form-item>
          <el-form-item v-if="registerForm.account && slideDrawing" prop="slide">
            <div class="flex_center c6 success_button">
              <i class="el-icon-check mr5 fs16" />
              验证成功
            </div>
          </el-form-item>
          <el-form-item v-else prop="slide">
            <div class="flex_center c6 check_button" @click="slideCheck">
              <i class="el-icon-help mr5 fs16" />
              点击按钮完成验证
            </div>
          </el-form-item>
          <el-form-item prop="code" label="验证码">
            <div class="flex_middle">
              <el-input v-model="registerForm.code" type="text" placeholder="请输入验证码" maxlength="4" clearable @input="registerForm.code = registerForm.code.replace(/\D/g, '')" />
              <el-button v-if="!isSend" style="height: 40px;" class="active_color ml20" :disabled="registerForm.account && !slideDrawing" @click="getCode">{{ str }}</el-button>
              <el-button v-if="isSend" style="height: 40px;" class="ml20" disabled>{{ countStr }}</el-button>
            </div>
          </el-form-item>
          <el-form-item prop="login_pass" label="登录密码">
            <el-input v-model="registerForm.login_pass" type="password" placeholder="请输入密码" auto-complete="new-password" show-password @keyup.native.13="submitRegister('registerForm')" />
          </el-form-item>
          <el-form-item prop="confirm_pass" label="确认密码">
            <el-input v-model="registerForm.confirm_pass" type="password" placeholder="请确认密码" show-password @keyup.native.13="submitRegister('registerForm')" />
          </el-form-item>
          <div class="mt40">
            <el-button type="primary" class="fs18 register_btn mb20" @click="submitRegister('registerForm')">注册</el-button>
            <div class="c6 pointer fs14 flex_center"><span>已有帐号？</span><span class="forget" @click="login">立即登录</span></div>
          </div>
        </el-form>
      </div>
    </div>
    <img src="@/assets/wave.png" class="wave w100 pf">
    <el-dialog :visible.sync="slideShow" width="420px">
      <slide-verify
        ref="slideblock"
        :l="42"
        :r="10"
        :w="380"
        :h="155"
        slider-text="请向右滑动滑块完成验证"
        :imgs="puzzleImgList"
        @success="onSuccess"
        @fail="onFail"
        @refresh="onRefresh"
        @fulfilled="onFulfilled"
      />
      <div class="mt5" :class=" msg == '验证成功' ? 'checkactive' : 'del'">{{ msg }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { sendsmsCode } from '@/api/common'
import { getCurVersion } from '@/api/user'
import { get, set, clearAll } from '@/utils/storage'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    const validateSlide = (rule, value, callback) => {
      if (!this.registerForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!/^1[3456789]\d{9}$/.test(this.registerForm.account)) {
        callback(new Error('请先输入正确的手机号'))
      } else if (!this.code && !this.slideDrawing) {
        callback(new Error('请先点击按钮完成验证'))
      } else {
        callback()
      }
    }
    const validateNewpass = (rule, value, callback) => {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value === '' || value === undefined) {
        callback(new Error('请输入密码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入8位及以上字母和数字组合的密码'))
      } else {
        if (this.registerForm.confirm_pass !== '' || this.registerForm.confirm_pass !== undefined) {
          this.$refs.registerForm.validateField('confirm_pass')
        }
        callback()
      }
    }
    const validateSurepass = (rule, value, callback) => {
      if (this.registerForm.login_pass === '' || this.registerForm.login_pass === undefined) {
        callback(new Error('请先输入密码'))
      }
      if (value === '' || value === undefined) {
        callback(new Error('请再次确认密码'))
      } else if (value !== this.registerForm.login_pass) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    const validateRegistercode = (rule, value, callback) => {
      if (!this.registerForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!this.code) {
        callback(new Error('请先获取短信验证码'))
      } else if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      registerForm: {
        account: '',
        login_pass: '',
        confirm_pass: '',
        code: '',
        company_name: '',
        duty: '',
        source: '',
        invitation_code: this.$route.query.code
      },
      codeForm: {},
      registerRules: {
        company_name: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        duty: [{ required: true, message: '请输入企业税号', trigger: 'change' }],
        source: [{ required: true, message: '请选择来源渠道', trigger: 'change' }],
        account: [{ required: true, validator: validateMobile, trigger: 'change' }],
        slide: [{ required: true, validator: validateSlide, trigger: 'change' }],
        code: [{ required: true, validator: validateRegistercode, trigger: 'change' }],
        login_pass: [{ required: true, validator: validateNewpass, trigger: 'change' }],
        confirm_pass: [{ required: true, validator: validateSurepass, trigger: 'change' }]
      },
      code: '',
      str: '获取验证码',
      countStr: '重新发送（60s）',
      isSend: false,
      timer: null,
      msg: '',
      slideShow: false,
      slideDrawing: false,
      slideText: '请向右滑动滑块完成验证',
      puzzleImgList: [
        require('@/assets/check1.png'),
        require('@/assets/check2.png'),
        require('@/assets/check3.jpg'),
        require('@/assets/check4.jpg'),
        require('@/assets/check5.png'),
        require('@/assets/check6.jpg'),
        require('@/assets/check7.jpg'),
        require('@/assets/check8.jpg')
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['version', 'updateVersion', 'versionContent', 'nodeAuth'])
  },
  created() {
    this.registerForm.invitation_code = this.$route.query.code
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName('ICP')[0].style.paddingLeft = 0
    })
  },
  methods: {
    ...mapActions('user', ['registerFn']),
    ...mapMutations('user', ['SET_UPDATEVERSION', 'SET_VERSIONCONTENT', 'SET_VERSION']),
    onSuccess() {
      this.msg = '验证成功'
      setTimeout(() => {
        this.slideShow = false
        this.slideDrawing = true
        this.slideText = '验证成功'
        this.$refs.registerForm.validateField('slide')
      }, 1000)
    },
    onFail() {
      this.msg = '验证失败'
    },
    onRefresh() {
      this.msg = ''
    },
    onFulfilled() {
      this.msg = ''
    },
    slideCheck() {
      this.$refs.registerForm.validateField(['account'], (err) => {
        if (!err) {
          this.slideShow = true
          this.$nextTick(() => {
            this.$refs.slideblock.reset()
          })
        }
      })
    },
    inputAccount() {
      this.registerForm.account = this.registerForm.account.replace(/\D/g, '')
      if (!this.registerForm.account) {
        this.slideDrawing = false
      }
    },
    login() {
      if (this.$route.query.code) {
        this.$router.push({ path: '/login?code=' + this.$route.query.code })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    getCode() {
      this.$refs.registerForm.validateField('account', (errorMessage) => {
        if (!errorMessage) {
          sendsmsCode({ account: this.registerForm.account }).then(data => {
            if (data) {
              this.code = 1
              this.isSend = true
              this.timer = null
              let time = 60
              this.timer = setInterval(() => {
                if (time === 0) {
                  this.str = '重新获取验证码'
                  this.countStr = '重新发送（60s）'
                  this.isSend = false
                  clearInterval(this.timer)
                } else {
                  time--
                  this.countStr = `重新发送（${time}s）`
                }
              }, 1000)
            }
          })
        }
      })
    },
    // 注册
    submitRegister(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.registerFn(this.registerForm)
          if (res.code === 200) {
            this.$message.success('注册成功!')
            if (this.timer) {
              clearInterval(this.timer)
            }
            setTimeout(() => {
              this.routerDump()
            }, 500)
          }
          return true
        } else {
          return false
        }
      })
    },
    async routerDump() {
      const res = await getCurVersion()
      if (res.code === 200) {
        const oldVersion = get('version')
        if (oldVersion && oldVersion.toLowerCase() !== res.data.version.toLowerCase() || !oldVersion) {
          // 更新内容描述
          this.SET_VERSIONCONTENT(res.data.employer_desc)
          // 显示弹框
          this.SET_UPDATEVERSION(true)
          // 本地存储版本号
          set('version', res.data.version)
        }
        set('pass', 'define')
        // 权限列表
        if (this.nodeAuth.length) {
          this.$router.replace('/home')
        } else {
          this.$message.error('暂无任何权限,请联系超级管理员')
        }
      } else {
        clearAll()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register_table {
    margin: 0;
    margin-bottom: 30px;
}
.registerfindPass{
  background-color: #F5F9FF;
  height: 100%;
  .registerfind_wrap{
    border-top: 6px solid #2d8cf0;
    background-color: #F5F9FF;
    background-image: url('../../assets/login_bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 6%;
    padding-bottom: 60px;
    .registerfind_body{
      width: 630px;
      // height: 600px;
      padding: 40px 50px;
      border-radius: 10px;
      box-shadow: 0 1px 14px 2px rgba(45, 140, 240, 0.09);
      margin: 0 auto;
      .registerfind_head{
        height: 80px;
        line-height: 80px;
        border-bottom: 1px solid #E3EDFF;
      }
      .next_btn{
        width: 310px;
        height: 46px;
      }
    }
  }
  .check_button{
    width: 100%;
    border-radius: 2px;
    border: 1px solid #e4e7eb;
    background-color: #f7f9fa;
    font-size: 14px;
    cursor: pointer;
  }
  .check_button:hover{
    color: #1890FF;
  }
  .success_button{
    width: 100%;
    border-radius: 2px;
    border:1px solid #52ccba;
    background-color: #d2f4ef;
    color: #52ccba;
    font-size: 14px;
    cursor: pointer;
  }
  .wave{
    bottom: 0;
  }
  .register-form {
  .forget {
    color: #2d8cf0;
  }

  .register_btn {
    height: 40px;
    width: 100%;
  }
}
}
.checkactive{
  color: #52ccba;
}
.mt40{
  margin-top: 40px;
}

</style>
